<template>
    <Dialog
            :open="open"
            :title="$t('tooltips.edit')"
            @close="closeDialog">
        <v-form ref="organizationForm" v-model="valid" @submit.prevent="save">
            <v-row>
                <v-col cols="12">
                    <v-text-field
                            v-model="organizationData.Name"
                            :rules="[$validations.required]"
                            required>
                        <template v-slot:label>
                            {{ $t('authentication.subscriptionName') }}<sup>*</sup>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="text-right">
                    <v-btn
                            :disabled="!valid"
                            :loading="loading"
                            class="py-6 accentText--text shadow-inverse"
                            color="accent"
                            depressed
                            @click="save">
                        {{ $t('save') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </Dialog>
</template>

<script>
import Dialog from "@/components/reusable/Dialog/Dialog";

export default {
  name: "SubscriptionEditDialog",
  components: {Dialog},
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    organization: {
      type: Object,
      required: false,
      default: () => ({
        OrganizationID: null,
        Name: '',
        Timezone: '',
      })
    }
  },
  data() {
    return {
      valid: false,
      loading: false,
      organizationData: {
        OrganizationID: null,
        Name: '',
        Timezone: '',
      }
    };
  },
  watch: {
    organization: {
      immediate: true,
      deep: true,
      handler(value) {
        const source = value || {};
        this.organizationData = {
          OrganizationID: source.OrganizationID || null,
          Name: source.Name || '',
          Timezone: source.Timezone || '',
        };
        if (this.$refs.organizationForm) {
          this.$refs.organizationForm.resetValidation();
        }
      }
    }
  },
  methods: {
    save() {
      this.$refs.organizationForm.validate();
      if (!this.valid || this.loading || !this.organizationData.OrganizationID) {
        return;
      }
      const url = this.$store.getters.organization(this.organizationData.OrganizationID);
      const payload = {
        Name: this.organizationData.Name,
        Timezone: this.organizationData.Timezone,
      };

      this.loading = true;
      this.axios.patch(url, payload, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then(() => {
        this.$store.dispatch('addNotification', {
          type: 'success',
          message: this.$t('success.organizationWasUpdated')
        });
        this.$emit('close', true);
      }).finally(() => {
        this.loading = false;
      });
    },
    closeDialog() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>

</style>
